import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import HomeLanding from "../views/HomeLanding";
import RequestFloatCash from "../views/RequestFloatCash";
import AgentRequestsFeed from "../views/AgentRequestsFeed";
import NearbyAgents from "../views/NearbyAgents";
import FloatLoanService from "../views/FloatLoanService";

export default function Home(props) {

	const appContext = useContext(AppContext);

	const [view, setView] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if (
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <HomeLanding />
		} else if (
			appContext.navSubItem === 'request_float' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <RequestFloatCash />
		} else if (
			appContext.navSubItem === 'agent_requests_feed' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <AgentRequestsFeed />
		} else if (
			appContext.navSubItem === 'nearby_agents' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <NearbyAgents />
		} else if (
			appContext.navSubItem === 'float_loan_service' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <FloatLoanService />
		}

		return null;
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		const _view = getView();
		if (_view) {
			setView(_view);
		}
	}, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem])

	//return desired view
	return view;
}